module.exports = __webpack_public_path__ + "static/img/personal_info.d807c11b.png";